
import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { scrollToSection } from 'app/components/enhancers/with-section-tab';
import { DisplayLink } from 'ui';

interface FactLinkProps {
  classNames?: string;
  section?: number;
  url?: string;
  children?: React.ReactNode;
  id?: string;
  urlOpenNew?: boolean;
  skipNavigation?: boolean;
}

export const FactLink: React.FC<FactLinkProps> = ({ id, classNames = '', section, children, url, urlOpenNew, 
  skipNavigation = false }) => {
  const className = `${classNames} fact-link`;
  const linkTo = section || url ? navigate.toSectionURL(section, url) : undefined;

  const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    section && scrollToSection(section);
  };

  const handleOnClick = skipNavigation ? handleScrollToSection : undefined;

  return (
    <DisplayLink componentId={id} className={className} url={linkTo} urlOpenNew={urlOpenNew} section={section} 
      onClick={handleOnClick} navigateToUrlForNewTab={!!url} >
      {children}
    </DisplayLink>
  );
};
